export default __webpack_public_path__ + "5770614b9793b56423a5d19a5a41410b.png";